document.addEventListener('DOMContentLoaded', function () {
  const textElement = document.querySelector('.balise_move');
  const container = document.getElementById('booster_scroll');

  // ---------- SURVOL : compatible Safari (mouseover/out + mouseenter/leave)
  const boosters = [
    { selector: '.booster_v1img', text: 'jeux de société' },
    { selector: '.booster_v2img', text: 'Offre et nouveautés' },
    { selector: '.booster_v3img', text: 'Pokémon' },
    { selector: '.booster_v4img', text: 'ondes mystiques' },
    { selector: '.booster_v5img', text: 'lune sacrée' }
  ];

  function updateTextWithGlitch(newText) {
    if (!textElement) return;
    textElement.classList.remove('glitch');
    // Force reflow (Safari-safe)
    // eslint-disable-next-line no-unused-expressions
    textElement.offsetHeight;
    textElement.textContent = newText;
    textElement.classList.add('glitch');
  }

  const supportsHover = window.matchMedia('(hover: hover)').matches;

  boosters.forEach(({ selector, text }) => {
    const el = document.querySelector(selector);
    if (!el) return;

    const update = () => updateTextWithGlitch(text);
    const reset  = () => updateTextWithGlitch('attirez la rareté');

    if (supportsHover) {
      // Safari compat: mouseover/mouseout sont plus “universels”
      el.addEventListener('mouseover', update);
      el.addEventListener('mouseout', reset);
      // on garde aussi mouseenter/mouseleave pour les navigateurs modernes
      el.addEventListener('mouseenter', update);
      el.addEventListener('mouseleave', reset);
    }

    // petit feedback au tap/clic
    el.addEventListener('click', () => {
      update();
      setTimeout(reset, 1200);
    }, { passive: true });
  });

  // ---------- AUTOSCROLL MOBILE (stoppe bien au 1er geste)
  const isMobile = () => window.innerWidth <= 768;

  if (isMobile() && container) {
    let scrollSpeed = 0.5;
    let stopped = false;

    const raf = (fn) => window.requestAnimationFrame(fn);

    const step = () => {
      if (!stopped && container.scrollWidth > container.clientWidth) {
        container.scrollLeft += scrollSpeed;
        if (container.scrollLeft + container.clientWidth >= container.scrollWidth - 1) {
          container.scrollLeft = 0;
        }
      }
      raf(step);
    };

    // laisse 1 frame au layout Safari
    setTimeout(() => raf(step), 300);

    ['touchstart', 'mousedown', 'wheel'].forEach(evt => {
      container.addEventListener(evt, () => { stopped = true; }, { once: true, passive: true });
    });

    // ---------- FLOTTEMENT (sans casser le transform du :hover desktop)
    const floatingImgs = document.querySelectorAll('.booster_floating');
    floatingImgs.forEach((img, index) => {
      let direction = 1;
      let pos = 0;
      const amplitude = 2 + Math.random();
      const speed = 0.3 + Math.random() * 0.2;

      setInterval(() => {
        pos += direction * speed;
        if (pos > amplitude || pos < -amplitude) direction *= -1;
        // on empile transform via style.setProperty pour ne pas écraser d’autres transforms
        img.style.setProperty('--float-y', `translateY(${pos}px)`);
        const base = getComputedStyle(img).getPropertyValue('--base-x') || '';
        img.style.transform = `${base} var(--float-y)`.trim();
      }, 30 + index * 5);
    });
  }
});
